import React, { useState } from 'react';
import { ModalTemplate } from './templates';
import './Modal.css';
import './CreateInspectionModal.css';   // reuse the Add-Inspection modal look

// The deformation analyses the user can add. Only the two EEMUA 159 pipelines
// exist for now; each maps to its standalone analysis page (opened by the
// sub-card's "Run Analysis" button) and can be added at most once.
export const DEFO_ANALYSES = [
  { kind: 'shell', standard: 'eemua159', title: 'EEMUA 159 Shell Deformation Analysis', route: 'shell-deformation' },
  { kind: 'floor', standard: 'eemua159', title: 'EEMUA 159 Floor Deformation Analysis', route: 'floor-deformation' },
];

export const defoKey = (a) => `${a.kind}_${a.standard}`;
export const defoAnalysisByKey = (key) => DEFO_ANALYSES.find((a) => defoKey(a) === key) || null;

export default function CreateDefoAnalysisModal({ existingKeys, onCancel, onCreate }) {
  const already = new Set(existingKeys || []);
  const [selected, setSelected] = useState(() => new Set());

  const toggle = (key) => {
    if (already.has(key)) return;
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  };

  const count = selected.size;

  function handleSave() {
    const picks = DEFO_ANALYSES.filter(
      (a) => selected.has(defoKey(a)) && !already.has(defoKey(a)),
    );
    if (picks.length > 0) onCreate(picks);
  }

  return (
    <ModalTemplate
      title="Create Analysis"
      onClose={onCancel}
      wide
      className="cim-modal"
      actions={
        <>
          <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={count === 0}>
            Save
          </button>
        </>
      }
    >
      <p className="cim-hint">
        Select one or more deformation analyses to add. Each analysis can only be
        added once.
      </p>

      <div className="cim-groups">
        <div className="cim-group">
          <div className="cim-group-label">Deformation Analysis</div>
          <div className="cim-items">
            {DEFO_ANALYSES.map((a) => {
              const key = defoKey(a);
              const alreadyAdded = already.has(key);
              const active = selected.has(key);
              return (
                <button
                  key={key}
                  type="button"
                  className={[
                    'cim-item',
                    alreadyAdded ? 'cim-item-existing' : '',
                    active ? 'cim-item-active' : '',
                  ].filter(Boolean).join(' ')}
                  onClick={() => toggle(key)}
                  disabled={alreadyAdded}
                  title={alreadyAdded ? 'Already added' : undefined}
                >
                  <span className="cim-item-code">{a.kind.toUpperCase()}</span>
                  <span className="cim-item-label">{a.title}</span>
                  {alreadyAdded
                    ? <span className="cim-item-existing-tick" title="Already added">✓</span>
                    : active && <span className="cim-item-check">✓</span>}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </ModalTemplate>
  );
}
